
import {VideotronTV} from './app/VideotronTV.js'
window.VideotronTV = VideotronTV;
